import { getDependentPaths } from 'app/modules/fintracStr/formUtils';
import { FintracFormSection } from 'app/modules/fintracStr/models';
import { isFieldBlank } from 'app/modules/fintracStr/renderConditions';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

export const FINTRAC_STR_RELATED_REPORTS_TAB_SECTION: FintracFormSection = {
  type: 'tabSection',
  repeatable: true,
  label: 'Related Reports',
  name: 'relatedReports',
  mustExistInPayload: true,
  mustHaveValueIfExist: false,
  defaultNumOfEntries: 0,
  fields: [
    {
      type: U21FormFieldTypes.TEXT,
      name: 'reportingEntityReportReference',
      label: "Reporting entity's report reference",
      mustExistInPayload: false,
      mustHaveValueIfExist: true,
      dependentPaths: (sectionIndex, fieldSectionIndex) =>
        getDependentPaths(
          undefined,
          ['reportDetails.ministerialDirectiveCode'],
          sectionIndex,
          fieldSectionIndex,
        ),
      hideIfTrue: {
        and: [
          {
            path: 'reportDetails.ministerialDirectiveCode',
            conditions: (value) => !isFieldBlank(value),
          },
        ],
      },
    },
    {
      type: U21FormFieldTypes.TEXT,
      name: 'reportingEntityTransactionReferences',
      label: "Reporting entity's transaction reference",
      defaultNumOfEntries: 0,
      repeatable: true,
      mustExistInPayload: false,
      mustHaveValueIfExist: true,
      defaultValue: '',
      dependentPaths: (sectionIndex, fieldSectionIndex) =>
        getDependentPaths(
          undefined,
          ['reportDetails.ministerialDirectiveCode'],
          sectionIndex,
          fieldSectionIndex,
        ),
      hideIfTrue: {
        and: [
          {
            path: 'reportDetails.ministerialDirectiveCode',
            conditions: (value) => !isFieldBlank(value),
          },
        ],
      },
    },
  ],
};
